import React from 'react';

import { useLanguage } from '../context/LanguageContext';

const Solution = () => {
    const { t } = useLanguage();

    const features = [
        {
            icon: '🔍',
            title: t('solution.features.naturalLanguage.title'),
            description: t('solution.features.naturalLanguage.description')
        },
        {
            icon: '💬',
            title: t('solution.features.whatsapp.title'),
            description: t('solution.features.whatsapp.description')
        },
        {
            icon: '🌐',
            title: t('solution.features.multiformat.title'),
            description: t('solution.features.multiformat.description')
        },
        {
            icon: '🔒',
            title: t('solution.features.security.title'),
            description: t('solution.features.security.description')
        },
        {
            icon: '⚡',
            title: t('solution.features.setup.title'),
            description: t('solution.features.setup.description')
        }
    ];

    const styles = {
        section: {
            padding: '100px 32px',
            backgroundColor: '#FFFFFF',
        },
        container: {
            maxWidth: '1400px',
            margin: '0 auto',
        },
        header: {
            textAlign: 'center',
            marginBottom: '60px',
        },
        h2: {
            fontSize: '48px',
            fontWeight: '800',
            marginBottom: '16px',
            color: '#2B2B2B',
        },
        highlight: {
            color: '#3457D5',
        },
        tagline: {
            fontSize: '28px',
            fontWeight: '700',
            color: '#3457D5',
            marginBottom: '16px',
        },
        subtext: {
            fontSize: '18px',
            color: '#6E6E6E',
            maxWidth: '700px',
            margin: '0 auto',
            lineHeight: '1.7',
        },
        grid: {
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: '32px',
        },
        card: {
            backgroundColor: '#FFFFFF',
            padding: '40px',
            borderRadius: '20px',
            border: '1px solid #E5E5E5',
            transition: 'all 0.3s',
            cursor: 'pointer',
        },
        icon: {
            fontSize: '48px',
            marginBottom: '20px',
            display: 'block',
        },
        cardTitle: {
            fontSize: '22px',
            fontWeight: '700',
            color: '#2B2B2B',
            marginBottom: '12px',
        },
        cardDesc: {
            fontSize: '16px',
            color: '#6E6E6E',
            lineHeight: '1.7',
        },
    };

    const isMobile = window.innerWidth < 768;
    if (isMobile) {
        styles.section.padding = '60px 20px';
        styles.h2.fontSize = '32px';
        styles.tagline.fontSize = '22px';
        styles.grid.gridTemplateColumns = '1fr';
        styles.card.padding = '28px';
    }

    return (
        <section style={styles.section}>
            <div style={styles.container}>
                <div style={styles.header}>
                    <h2 style={styles.h2}>
                        {t('solution.title')}<span style={styles.highlight}>{t('solution.titleHighlight')}</span>
                    </h2>
                    <p style={styles.tagline}>{t('solution.tagline')}</p>
                    <p style={styles.subtext}>
                        {t('solution.subtext')}
                    </p>
                </div>

                <div style={styles.grid}>
                    {features.map((feature, index) => (
                        <div
                            key={index}
                            style={styles.card}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.transform = 'translateY(-8px)';
                                e.currentTarget.style.boxShadow = '0 20px 40px rgba(52,87,213,0.15)';
                                e.currentTarget.style.borderColor = '#3457D5';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.transform = 'translateY(0)';
                                e.currentTarget.style.boxShadow = 'none';
                                e.currentTarget.style.borderColor = '#E5E5E5';
                            }}
                        >
                            <span style={styles.icon}>{feature.icon}</span>
                            <h3 style={styles.cardTitle}>{feature.title}</h3>
                            <p style={styles.cardDesc}>{feature.description}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Solution;
